import Hero from './components/Hero';
import CategoryGrid from './components/CategoryGrid';
import FeaturedItems from './components/FeaturedItems';
import SeoContent from './components/SeoContent';
import TestimonialSection from './components/TestimonialSection';
import FinalCTA from './components/FinalCTA';
import Footer from './components/Footer';

const siteUrl = import.meta.env.VITE_SITE_URL || 'https://cssspreadsheet.makeup';

const websiteJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: 'CSSBuy Spreadsheet Hub',
  url: siteUrl + '/',
  description:
    'Discover verified CSSBuy, Kakobuy, Superbuy and Oopbuy spreadsheets with real QC data, price comparisons, and daily updated shopping lists. Find sneakers, streetwear, hoodies, and luxury replica items from trusted sellers.',
  image:
    'https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/d367cf6745ee47f3fc82c76d3a54c50c.png',
  inLanguage: 'en',
  potentialAction: {
    '@type': 'SearchAction',
    target: {
      '@type': 'EntryPoint',
      urlTemplate: siteUrl + '/search?q={search_term_string}',
    },
    'query-input': 'required name=search_term_string',
  },
};

export default function Home() {
  return (
    <main>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(websiteJsonLd) }}
      />
      <Hero />
      <CategoryGrid />
      <FeaturedItems />
      <SeoContent />
      <TestimonialSection />
      <FinalCTA />
      <Footer />
    </main>
  );
}